export default function PageHeader({ eyebrow, title, description, children }) {
  return (
    <section className="pt-20 md:pt-28 pb-8 md:pb-12 border-b border-white/5">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        {eyebrow && (
          <div className="text-xs uppercase tracking-[0.24em] text-zinc-500 mb-6" data-testid="page-eyebrow">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display font-bold text-5xl md:text-6xl lg:text-7xl tracking-tight max-w-4xl text-balance" data-testid="page-title">
          {title}
        </h1>
        {description && (
          <p className="mt-8 max-w-2xl text-lg text-zinc-400 leading-relaxed" data-testid="page-description">
            {description}
          </p>
        )}
        {children && <div className="mt-10">{children}</div>}
      </div>
    </section>
  );
}
